module.exports = __webpack_public_path__ + "static/media/loader.8d45eca0.gif";